import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialGoCardlessReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const gocardlessSlice = createSlice({
    name: "GoCardless",
    initialState: { ...initialGoCardlessReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default gocardlessSlice;
